<template>
    <div>
        <app-new-breadcrumb></app-new-breadcrumb>
        <div class="main">
            <div class="description">
                <div class="description-text">
                    <h2>{{ $t("creditRating") }}</h2>
                    <p>{{ $t("creditRatingDescription") }}</p>
                </div>
                <div class="description-img">
                    <img src="https://resources.fia.ba/file/A78BAB77-DA08-ED11-8B83-00155D1E1252.jpg">
                </div>
            </div>
            <div class="main-part">
                <div class="big-card">
                    <div class="big-card-title">
                        <i class="fa fa-solid fa-desktop"></i>
                        <h3>{{ $t("creditRatingDecriptionTitle") }}</h3>
                    </div>
                    <p v-html="$t('creditRatingDecriptionText')"></p>
                </div>
                <div class="big-card">
                    <div class="big-card-title">
                        <i class="fa fa-solid fa-desktop"></i>
                        <h3>{{ $t("creditRatingTypes") }}</h3>
                    </div>
                    <a href="https://resources.fia.ba/file/9F2310E7-2D61-EF11-8B90-00155D1E1316.pdf" target="_blank">{{ $t("creditRatingCertificate") }}</a>
                    <!-- <a href="">{{ $t("goldCreditRating") }}</a>
                    <a href="">{{ $t("silverCretitRating") }}</a>
                    <a href="">{{ $t("bronzeCreditRating") }}</a> -->
                </div>
                <div class="big-card">
                    <div class="big-card-title">
                        <i class="fa fa-solid fa-desktop"></i>
                        <h3>{{ $t('orderTitle') }}</h3>
                    </div>
                    <p>{{ $t('orderProductDescription') }}</p>
                    <a href="https://proizvodi.fia.ba/Boniteti/Zahtjev" target="_blank">
                        <div class="big-card-btn">{{$t('requestForm')}}</div>
                    </a>
                </div>
                <div class="big-card">
                    <div class="big-card-title">
                        <i class="fa fa-solid fa-desktop"></i>
                        <h3>{{$t('priceList')}}</h3>
                    </div>
                    <p>{{ $t('priceListButtonDescription') }}</p>
                    <router-link :to="{ name: $t('priceListRouteName')}" class="big-card-btn">{{$t('priceList')}}</router-link>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "../../common/Breadcrumb.vue";

export default {
    data() {
        return {
        }
    },
    components: {
        appNewBreadcrumb: Breadcrumb,
    },
    methods: {
    },
    computed: {
        ...mapGetters(["getContentById", "getSelectedLanguage", "getContentByUrl"]),
       
    },
}
</script>

<style scoped>
</style>
